const base = {
  paddingTop: 's32',
  paddingBottom: 's32',
  borderTopColor: 'coolGrey.30',
  borderTopWidth: '1px',
  borderTopStyle: 'solid',
  '&:first-of-type': {
    borderColor: 'coolGrey.30',
    borderTopWidth: '1px',
    borderTopStyle: 'solid'
  },
  '&:last-of-type': {
    borderColor: 'coolGrey.30',
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid'
  }
};

const chart = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const co = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const edu = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const press = {
  default: {
    ...base,
    backgroundColor: 'indigo.100'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const spark = {
  default: {
    ...base,
    backgroundColor: 'indigo.90'
  },
  transparent: {
    ...base,
    background: 'transparent'
  }
};

const item = {
  products: {
    chart,
    co,
    edu,
    press,
    spark
  }
};

export const itemVariants = Object.keys(chart);
export type ItemType = 'default' | 'transparent';

export default item;
